import React, { useState, useEffect, useMemo, forwardRef, useRef } from "react";
import DetailModal from "../../components/DetailModal";
import { MdAdd } from "react-icons/md";
import { actionColor } from "../../utils/general";
import { FaChevronDown } from "react-icons/fa6";
import { FaChevronUp } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import {
  Table,
  Select,
  LoadingOverlay,
  Button,
  Tooltip,
  Group,
  Input,
  Combobox,
  InputBase,
  TextInput,
  useCombobox,
  Checkbox,
  Popover,
  Modal,
  Portal,
  Text,
} from "@mantine/core";
// import { useDebouncedCallback } from '@mantine/hooks';
import { TfiViewListAlt } from "react-icons/tfi";
import CustomTable from "../../components/Table";
import { MdNumbers } from "react-icons/md";
import { FaUser } from "react-icons/fa6";
import { GrResources } from "react-icons/gr";
import { TbDatabaseOff } from "react-icons/tb";
import { BsFilterSquare } from "react-icons/bs";
import { LiaFilterSolid } from "react-icons/lia";
import { useAppDispatch } from "../../redux/hooks";
import { FaRegClock } from "react-icons/fa6";
import { LuChevronsUpDown } from "react-icons/lu";
import { notifications } from "@mantine/notifications";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";
import PermissionAction from "../../components/permissions/PermissionAction";
import ExportIcon from "../../svg/exportIcon";
import { LuMoreHorizontal } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import FloorIcon from "../../svg/floorIcon";
import ChairIcon from "../../svg/chairIcon";

import SiteIcon from "../../svg/addressIcon";
import { FaRegUser } from "react-icons/fa";
import { IoMdExpand } from "react-icons/io";
import { IoEllipseSharp, IoFilterOutline } from "react-icons/io5";
import { GoQuestion } from "react-icons/go";
import { IoMdClose } from "react-icons/io";
import { useClickOutside } from "@mantine/hooks";
import ListIcon from "../../svg/listIcon";
import CustomSelect from "../../components/CustomSelect";
import { CiViewList } from "react-icons/ci";
import {
  formatTimestampToDate,
  findObjDifference,
  getTimestampForPeriod,
} from "../../utils/general";
import {
  useGetLogsQuery,
  useLazyGetLogsQuery,
  useLazyExportLogsQuery,
  useGetUsersQuery,
  useLazyGetFloorsQuery,
  useLazyGetUsersQuery,
  useGetLocationQuery,
} from "../../redux/slices/api.slice";
import "./log.css";
import Container from "../../components/Container";

const Log = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [getLogs, { data, isLoading, isError, status }] = useLazyGetLogsQuery();
  const [
    getFloors,
    {
      data: allFloors,
      isLoading: loadingFloors,
      isError: errorFloors,
      isFetching: isFetchingFloors,
    },
  ] = useLazyGetFloorsQuery();
  const { data: allLocations } = useGetLocationQuery("");
  const [getUsers, { data: users }] = useLazyGetUsersQuery();
  const [usersList, setUsersList] = useState([{ label: "All", value: "" }]);
  const [locations, setLocations] = useState([]);

  const [
    exportLogs,
    { data: logFile, isLoading: loadingFile, isFetching: isFetchingExport },
  ] = useLazyExportLogsQuery();

  const TimeData = [
    { label: "Today", value: "today" },
    { label: "Week", value: "week" },
    { label: "Month", value: "month" },
    { label: "Year", value: "year" },
  ];
  const resources = [
    { value: "all", label: "All", icon: SiteIcon },
    { value: "location", label: "Sites", icon: SiteIcon },
    { value: "desk", label: "Desks", icon: ChairIcon },
    { value: "floor", label: "Floors", icon: FloorIcon },
  ];
  const [token, setToken] = useState([]);

  const [timeFilter, setTimeFilter] = useState(() => {
    const filters = localStorage.getItem("audit-log-filters");

    return filters ? JSON.parse(filters).timeFilter : "week";
  });

  const [resource, setResource] = useState(() => {
    const filters = localStorage.getItem("audit-log-filters");

    return filters ? JSON.parse(filters).resource : "all";
  });
  const [filteredData, setFilteredData] = useState([]);
  const [sortTimestamp, setSortTimestamp] = useState(true);
  const [filterParams, setFilterParams] = useState({
    locationID: "",
    floorID: "",
    action: {
      all: true,
      create: false,
      update: false,
      delete: false,
      "status change": false,
      "sensor unassignment": false,
      live: false,
      "sensor assignment": false,
    },
    user: "",
  });
  const [usersToken, setUsersToken] = useState(null);
  const [filterParamsList, setFilterParamsList] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(() => {
    const filters = localStorage.getItem("audit-log-filters");
    return filters ? JSON.parse(filters).limit : "20";
  });
  const [debouncedLimit, setDebouncedLimit] = useState("");
  const timeEnd = useMemo(() => {
    return new Date().getTime();
  }, [timeFilter]);

  useEffect(() => {
    if (allLocations) {
      setLocations(allLocations);
    }
  }, [allLocations]);
  useEffect(() => {
    getUsers("");
  }, []);

  useEffect(() => {
    if (users) {
      const adminsUsers = users.users
        .filter((user) => user.role.toLowerCase().includes("admin"))
        .reduce((acc, obj) => {
          acc = [...acc, { label: obj.email, value: obj.id }];
          return acc;
        }, []);
      if (adminsUsers.length === 0 && users.nextPaginationToken?.id) {
        // fetch more users
        getUsers(users.nextPaginationToken?.id);
      }
      setUsersList((prev) => [...prev, ...adminsUsers]);
      setUsersToken(users.nextPaginationToken?.id);
    }
  }, [users]);

  useEffect(() => {
    let actions = "";
    const filters = Object.entries(filterParams).reduce((acc, [key, value]) => {
      if (key === "action") {
        const actionsArr = Object.keys(value).filter(
          (k) => value[k] && k !== "all"
        );
        actions = actionsArr.join(",");
      } else if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});

    const f = {
      ...filters,
      ...(actions && { action: actions }),
      ...(resource !== "all" && { targetType: resource }),
    };
    setFilterParamsList(f);
  }, [filterParams, resource]);

  const [floors, setFloors] = useState([{ label: "All", value: "" }]);
  useEffect(() => {
    if (allFloors) {
      const updated = allFloors?.map((floor) => {
        return { label: floor.name, value: floor.id };
      });

      updated && !errorFloors
        ? setFloors([{ label: "All", value: "" }, ...updated])
        : setFloors([{ label: "All", value: "" }]);
    }
  }, [allFloors, errorFloors]);

  useEffect(() => {
    localStorage.setItem(
      "audit-log-filters",
      JSON.stringify({
        timeFilter,
        resource,
        limit,
      })
    );
  }, [timeFilter, resource, limit]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("timeSpan", timeFilter);
    params.set("resource", resource);
    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true,
    });
  }, [location.search, location.pathname, timeFilter, resource]);

  useEffect(() => {
    if (logFile) {
      const link = document.createElement("a");
      link.href = logFile;
      link.setAttribute("download", `export-log.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [logFile]);

  const handleExport = async () => {
    const timeStart = getTimestampForPeriod(timeFilter);
    const timeEnd = new Date().getTime();
    exportLogs({ resource, timeStart, timeEnd });
  };

  const [totalPages, setTotalPages] = useState(1);

  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [logsDetail, setLogDetails] = useState(null);

  const handleTimestampSorting = () => {
    const updated = [...filteredData].sort((a, b) =>
      sortTimestamp ? a.timestamp - b.timestamp : b.timestamp - a.timestamp
    );
    setFilteredData(updated);
    setSortTimestamp(!sortTimestamp);
  };

  const rows =
    filteredData.length > 0
      ? filteredData.map((item) => {
          return (
            <Table.Tr key={item.id}>
              <Table.Td>{item.username}</Table.Td>

              <Table.Td>
                <div className="flex justify-center items-center ">
                  <div
                    style={{
                      background: actionColor(item.action).bgClr,
                      color: actionColor(item.action).clr,
                      border: `1px solid ${actionColor(item.action).clr}`,
                    }}
                    className={`rounded-[100px] px-3 py-[2px] w-fit flex gap-2 items-center capitalize `}
                  >
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{
                        background: actionColor(item.action).clr,
                      }}
                    />
                    {item.action}
                  </div>
                </div>
              </Table.Td>
              <Table.Td>
                <p>{item.targetName} </p>
              </Table.Td>

              <Table.Td>{formatTimestampToDate(item.timestamp)}</Table.Td>

              <Table.Td>
                <div className="flex items-center justify-center">
                  {(item.oldValue || item.newValue) && (
                    <Button
                      size="sm"
                      variant="outline"
                      radius="md"
                      leftSection={<CiViewList className="text-2xl" />}
                      onClick={() => {
                        setOpenDetailModal(true);
                        setLogDetails({
                          oldValue:
                            item.oldValue && isValidJSON(item.oldValue)
                              ? JSON.parse(item.oldValue)
                              : item.oldValue,
                          newValue:
                            item.newValue && isValidJSON(item.newValue)
                              ? JSON.parse(item.newValue)
                              : item.newValue,
                          action: item.action,
                          type: item.targetType,
                          targetName: item.targetName,
                          parentName: item.parentName,
                        });
                      }}
                    >
                      View
                    </Button>
                  )}
                </div>
              </Table.Td>
            </Table.Tr>
          );
        })
      : [];
  const columnsLabels = [
    {
      label: "Username",
      icon: null,
      handler: () => {},
    },
    {
      label: "Action",
      icon: IoFilterOutline,
      handler: () => {},
    },
    { label: "Affected Entity", icon: null, handler: () => {} },
    {
      label: "Timestamp",
      icon: LuChevronsUpDown,
      handler: handleTimestampSorting,
    },
    { label: " ", icon: null, handler: () => {} },
  ];

  const columns = columnsLabels.map((column, index) => {
    return (
      <Table.Th
        key={index}
        className={
          index === 0
            ? "rounded-ss-[10px]"
            : index === columnsLabels.length - 1 && "rounded-se-[10px]"
        }
      >
        <ColumnLabel
          label={column.label}
          Icon={column.icon}
          handler={column.handler}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          actionColor={actionColor}
        />
      </Table.Th>
    );
  });

  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (data) {
      setFilteredData(data.Data);

      setToken((prevToken) => {
        const exists = prevToken.find(
          (item) => item.page === currentPage || item.t === data.PaginationToken
        );
        if (!exists) {
          return [
            ...prevToken,
            { page: currentPage, t: data.PaginationToken || null },
          ];
        }
        return prevToken;
      });

      setTotalPages(Math.ceil(data.Total / parseInt(limit)));
    }
  }, [data, limit]);

  useEffect(() => {
    if (isError) {
      setFilteredData([]); // temp solution
    }
  }, [isError]);

  useEffect(() => {
    const crumbs = [
      {
        name: "Home",
        route: "/",
      },
      {
        name: "Audit log",
        route: "/log",
      },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, [dispatch]);

  const handleNext = () => {
    const timeStart = getTimestampForPeriod(timeFilter);

    const nextpage = currentPage + 1;
    const currentToken = token.find((t) => t.page === currentPage)?.t;

    getLogs({
      timeStart,
      timeEnd,
      limit,
      filters: filterParamsList,
      PaginationToken: currentToken,
    });

    setCurrentPage(nextpage);
  };

  const handlePrev = () => {
    const timeStart = getTimestampForPeriod(timeFilter);
    const prevPage = currentPage - 1;

    const currentToken = token.find((t) => t.page === prevPage - 1)?.t;

    getLogs({
      timeStart,
      timeEnd,
      filters: filterParamsList,
      PaginationToken: prevPage === 1 ? null : currentToken,
      limit: limit,
    });
    setCurrentPage(prevPage);
  };

  const handleFilter = () => {
    setCurrentPage(1);
    setToken([]);
    const timeStart = getTimestampForPeriod(timeFilter);

    getLogs({
      timeStart,
      timeEnd,
      limit,
      filters: filterParamsList,
    });
  };
  useEffect(() => {
    handleFilter();
  }, [limit, timeFilter, filterParamsList]);
  useEffect(() => {
    getFloors(filterParams.locationID);

    setFilterParams({
      ...filterParams,
      floorID: "",
    });
  }, [filterParams.locationID]);

  const locationsData = useMemo(() => {
    const updated = locations.map((location) => {
      return { value: location.id, label: location.name };
    });
    return [{ label: "All", value: "" }, ...updated];
  }, [locations]);

  // const handleDebounceLimit = useDebouncedCallback((value) => {
  //   setDebouncedLimit(value);
  // }, 500);

  return (
    <PermissionAction operation="R" resource="logs">
      <Container>
        <div className="flex justify-between items-center w-full my-10">
          <div className=" flex gap-4 items-end mb-8">
            <h1 className="font-[500] text-5xl"> Audit Log</h1>
            <span className="text-grayText4 text-5xl">{data?.Total}</span>
          </div>
          <Select
            checkIconPosition="right"
            label={
              <div className="font-light  text-sm pb-1 text-grayText3 flex gap-[6px]">
                <SiteIcon width={18} height={18} fill="#4D5F7A" />
                <span>Site</span>
              </div>
            }
            data={locationsData}
            onChange={(value) =>
              setFilterParams({ ...filterParams, locationID: value })
            }
            value={filterParams.locationID}
            allowDeselect={false}
          />
        </div>
        <div className="flex justify-between items-center mb-10">
          <FiltersBar
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            usersList={usersList}
            floors={floors}
            isFetchingFloors={isFetchingFloors}
            resources={resources}
            resource={resource}
            setResource={setResource}
            limit={limit}
            TimeData={TimeData}
            timeFilter={timeFilter}
            setTimeFilter={setTimeFilter}
            setLimit={setLimit}
          />
          <Button
            loading={isFetchingExport}
            color={"#D5DAE1"}
            variant="default"
            radius="xl"
            size="md"
            loaderProps={{ type: "dots" }}
            className={`w-full !text-[#404F65]  `}
            onClick={() => {
              handleExport();
            }}
            leftSection={<ExportIcon fill="#404F65" />}
          >
            Export
          </Button>
        </div>

        <div className="relative border border-grayText4 border-solid rounded-[10px]">
          <CustomTable
            rows={rows}
            columns={columns}
            isLoading={status === "pending"}
            isError={isError}
          />

          {rows.length !== 0 && !isError && (
            <div className="w-full flex gap-4 justify-between items-center p-4 border-top">
              <div className="flex gap-4 items-center">
                <button
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                  className={`btn ${
                    currentPage === 1
                      ? "bg-[#F7F8F9] text-lightGray2 cursor-not-allowed"
                      : "bg-white text-grayText hover:bg-grayText4  "
                  }`}
                >
                  Previous
                </button>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className={`btn ${
                    currentPage === totalPages
                      ? "bg-[#F7F8F9] text-lightGray2 cursor-not-allowed"
                      : "bg-white text-grayText hover:bg-grayText4"
                  }`}
                >
                  Next
                </button>
              </div>
              <div className="text-base text-grayText">
                Page {currentPage} of {totalPages}
              </div>
            </div>
          )}
          <DetailModal
            openDetailModal={openDetailModal}
            setOpenDetailModal={setOpenDetailModal}
            logsDetail={logsDetail}
            locations={locations}
          />
        </div>
      </Container>
    </PermissionAction>
  );
};

export default Log;

const ColumnLabel = ({
  label,
  handler,
  Icon,
  filterParams,
  setFilterParams,
  actionColor,
}) => {
  const toggleAction = (actionName) => {
    setFilterParams((prevParams) => {
      const updatedAction =
        actionName === "all"
          ? {
              all: true,
              create: false,
              update: false,
              delete: false,
              "status change": false,
              "sensor unassignment": false,
              live: false,
              "sensor assignment": false,
            }
          : {
              ...prevParams.action,
              all: false,
              [actionName]: !prevParams.action[actionName],
            };
      return { ...prevParams, action: updatedAction };
    });
  };

  const actionLabels = [
    { name: "all", label: "Select All" },
    { name: "create", label: "Create" },
    { name: "delete", label: "Delete" },
    { name: "update", label: "Update" },
    { name: "live", label: "Live" },
    { name: "status change", label: "Status change" },
    { name: "sensor assignment", label: "Sensor assignment" },
    { name: "sensor unassignment", label: "Sensor unassignment" },
  ];
  return (
    <div
      className={label === "Action" ? "flex items-center justify-center" : ""}
    >
      {Icon ? (
        <div className="flex gap-4 items-center">
          <span>{label}</span>
          {label === "Action" ? (
            <Popover radius="lg" position="bottom" withArrow shadow="md">
              <Popover.Target>
                <div
                  onClick={handler}
                  className="text-[16px] flex justify-center items-center cursor-pointer "
                >
                  <Icon />
                </div>
              </Popover.Target>
              <Popover.Dropdown>
                <div className="flex justify-center flex-col gap-4 py-2">
                  {actionLabels.map(({ name, label }) => (
                    <Checkbox
                      key={name}
                      checked={filterParams.action[name]}
                      label={
                        name === "all" ? (
                          <div className="px-3 text-md">{label}</div>
                        ) : (
                          <div
                            style={{
                              background: actionColor(name).bgClr,
                              color: actionColor(name).clr,
                              border: `1px solid ${actionColor(name).clr}`,
                            }}
                            className={`rounded-[100px] px-3 py-[2px] w-fit flex gap-2 items-center `}
                          >
                            <div
                              className="w-2 h-2 rounded-full"
                              style={{
                                background: actionColor(name).clr,
                              }}
                            />
                            {label}
                          </div>
                        )
                      }
                      onChange={() => toggleAction(name)}
                    />
                  ))}
                </div>
              </Popover.Dropdown>
            </Popover>
          ) : (
            <Icon onClick={handler} className="text-[16px] cursor-pointer" />
          )}
        </div>
      ) : (
        <span>{label}</span>
      )}
    </div>
  );
};

const FiltersBar = ({
  filterParams,
  setFilterParams,
  usersList,
  floors,
  isFetchingFloors,
  resources,
  resource,
  setResource,
  limit,
  TimeData,
  timeFilter,
  setTimeFilter,
  setLimit,
}) => {
  const filterTypes = [
    { label: "records limit", data: null },
    { label: "users", data: usersList },
    { label: "resources", data: resources },
    { label: "floor", data: floors },
    { label: "Time Range", data: TimeData },
  ];
  const getValue = (label) => {
    switch (label) {
      case "records limit":
        return limit;
      case "users":
        return filterParams.user;
      case "resources":
        return resource;
      case "floor":
        return filterParams.floorID;
      case "Time Range":
        return timeFilter;

      default:
        break;
    }
  };
  const handleChange = (label, value) => {
    switch (label) {
      case "records limit":
        setLimit(value);
        break;
      case "users":
        setFilterParams((prev) => ({ ...prev, user: value }));
        break;
      case "resources":
        setResource(value);
        break;
      case "floor":
        setFilterParams((prev) => ({ ...prev, floorID: value }));
        break;
      case "Time Range":
        setTimeFilter(value);
        break;
      default:
        break;
    }
  };
  return (
    <div className="flex gap-4">
      {filterTypes.map((type) => {
        return (
          <SelectFilter
            label={type.label}
            key={type.label}
            data={type.data}
            value={getValue}
            setValue={handleChange}
          />
        );
      })}
      {/* <SelectFilter label={"Add Filters"} /> */}
    </div>
  );
};

const SelectFilter = ({
  data = [],
  label,
  value,
  setValue,
}: {
  data?: any[];
  label: string;
  value: any;
  setValue: any;
}) => {
  const [opened, setOpened] = useState(false);
  const [limitVal, setLimitVal] = useState(value(label));
  const renderDropdownContent = () => {
    if (label === "records limit") {
      const validateInput = (value) => {
        if (!value || value < 1 || value > 100) {
          return "Limit must be between 1 and 100";
        }
      };
      return (
        <div className="py-2">
          <div className="mb-4">
            <TextInput
              value={limitVal}
              radius="sm"
              label={
                <p className="text-sm text-grayText5 font-light mb-2">
                  Records limit per page
                </p>
              }
              type="number"
              className="w-full"
              onChange={(e) => setLimitVal(e.currentTarget.value)}
              min={0}
              error={validateInput(limitVal)}
            />
          </div>
          <Button
            className="!w-full"
            radius="md"
            disabled={limitVal < 1 || limitVal > 100 || !limitVal}
            onClick={() => {
              setValue(label, limitVal);
              setOpened(false);
            }}
          >
            Save
          </Button>
        </div>
      );
    }
    return (
      <div className="w-full flex flex-col">
        {data?.length > 0 &&
          data.map((item) => (
            <p
              key={item.label}
              onClick={() => {
                setValue(label, item.value);
                setOpened(false);
              }}
              className="hover:bg-lightGray break-all text-sm rounded-md py-2 px-2 cursor-pointer flex justify-between items-start gap-4"
            >
              {item.label}
              {item.value === value(label) && (
                <FaCheck className="text-sm text-grayText6" />
              )}
            </p>
          ))}
      </div>
    );
  };
  const renderLabel = (label, data) => {
    const val = data?.find((item) => item.value === value(label))?.label;
    switch (label) {
      case "records limit":
        return value(label) === 1
          ? `${value(label)} record`
          : `${value(label)} records`;
      case "users":
        return !value(label) ? `All users` : val;
      case "resources":
        return value(label) === "all" ? `All resources` : `${val} resource`;
      case "floor":
        return !value(label) ? `All Floors` : val;
      case "Time Range":
        return val;
      default:
        break;
    }
  };

  return (
    <div>
      <Popover
        position="bottom"
        shadow="md"
        radius="lg"
        opened={opened}
        onChange={setOpened}
        zIndex={1000}
      >
        <Popover.Target>
          <div
            onClick={() => setOpened((o) => !o)}
            className="rounded-[100px] cursor-pointer px-5  text-white bg-black py-2 flex gap-4 items-center justify-between min-w-[150px]  max-w-[200px]  "
          >
            <Text className="truncate text-base">
              {renderLabel(label, data)}
            </Text>
            {label === "Add Filters" ? (
              <MdAdd className="text-md text-white" size={20} fill="white" />
            ) : opened ? (
              <FaChevronUp className="text-sm" />
            ) : (
              <FaChevronDown className="text-sm" />
            )}
          </div>
        </Popover.Target>
        <Popover.Dropdown
          className={"!p-[10px] !min-w-[200px] !max-w-[270px] max-h-[150px]"}
        >
          {renderDropdownContent()}
        </Popover.Dropdown>
      </Popover>
    </div>
  );
};
